module.exports = __webpack_public_path__ + "static/media/img_18-29.fad5617f.png";